import { render, staticRenderFns } from "./SaveContact.vue?vue&type=template&id=1a47ddf8&scoped=true&"
import script from "./SaveContact.vue?vue&type=script&lang=js&"
export * from "./SaveContact.vue?vue&type=script&lang=js&"
import style0 from "./SaveContact.vue?vue&type=style&index=0&id=1a47ddf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47ddf8",
  null
  
)

export default component.exports